import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  ResetAppState,
  ToggleModal,
  ResetNotesTab,
  ResetEmailTab,
  ResetHistoryTab,
  GetScheduleVisitsCards,
  GetScheduleVisitsLV,
  GetPendingFilesCards,
  GetPendingFilesLV,
  GetPatientInfo,
  GetHeaderInfo,
  GetNotes,
  GetNotesV2,
  ResetPatientInfo,
  GetProductInfo,
  GetProductInfoV2,
  GetPatientMedicalNecessityPDFData,
  GetSoapNoteInfo,
  GetConsultQuestions,
  SetProductInfo,
  GetProductList,
  GetChangeProductList,
  ResetChangeProductList,
  GetQtyByProduct,
  SaveProductChanges,
  ChangeProductForOrder,
  ToggleProductChangeModal,
  GetOrderNotes,
  GetPatientNotes,
  GetMedicalOrderNotes,
  GetMedicalPatientNotes,
  SetSelectedTab,
  GetEmail,
  GetHistory,
  GetEmailTemplate,
  GetEmailTemplateFromSalesforce,
  GetApproveEmailTemplatesFromSalesforce,
  GetDenyEmailTemplatesFromSalesforce,
  GetScheduleEmailTemplatesFromSalesforce,
  GetDenialReasons,
  DenialAndEmail,
  ClearEmailAndDenyData,
  SetDenialAndSendValue,
  GetSubjectAndMail,
  GetSubjectAndMailForAllTemplates,
  GetSubjectAndMailFromSalesforce,
  ResetSubjectAndMailFromSalesforce,
  GetApproveAndEmailPrepInfo,
  GetOrderAndPrescriberFlags,
  ResetOrderAndPrescriberFlags,
  ResetApproveAndMailData,
  SetApproveAndMailData,
  SetApproveAndMailMainData,
  HandleGlobalValueChange,
  OnApproveAndMailClick,
  ToggleErrorModal,
  SetModalAlertOpen,
  SetStartVisit,
  SetAddNoteValue,
  SetAddSoapNoteValue,
  AddNote,
  AddSoapNote,
  ClearAddNoteData,
  GetTokenAndStartVist,
  GetSendOrderToCSReasons,
  SendOrderToCS,
  SetSendOrderToCSData,
  ResetSendOrderToCS,
  GetCallPatientDetails,
  ResetCallPatientDetails,
  SetCallPatientDetails,
  CallToPatient,
  CallToPatientPhys,
  SetModalTwilioAlertOpen,
  EmailPatientDetails,
  ClearEmailPatientData,
  GetTextPatientTemplates,
  TextPatient,
  ResetTextPatientDetails,
  CallDetails,
  CallEnd,
  ApproveAndMailSubmit,
  CompleteVisitAndSendEmail,
  LogError,
  LogOff,
  CheckPdfExists,
  SearchData,
  ClearSearchData,
  GetDoseSpot,
  GetDoseSpotV2,
  ResetDoseSpot,
  OrderCallSummaryReasons,
  SetCallSummary,
  InsertCallSummary,
  SetFilterBy,
  ClearPendingFilesApiStatus,
  ClearScheduledVisitsApiStatus,
  SetCmnTemplateFormField,

  SetSoapNoteTemplate,
  GetSoapNoteTemplates,
  GetPatientUploads,

  DosespotGetPatientPrescriptionsByOrderRequest,

  GetProductInfoV3,
  ClearProductInfoV3,

  GetEmailReasons,

  AddProduct,
  GetProductCost,
  ResetProductCost,

  GetSavedFlags,
  SaveFlags,
  ResetSavedFlags,

  SaveExtendedConsult,

  VerifyPIN,
  RemoveOrdersFromLV,
  ResetApproveAndEmailPrepInfo,
  ResetProductInfoV2,
  SendPasswordRecoveryOTP,
  ValidatePasswordRecoveryOTP,
  ResetPasswordUsingPasswordRecoveryOTP,
  ClearRecoverPassword,

  ValidateToken,

  GetPDFInfo,

  GetTasks,
  GetTaskByOrderId,
  UpdateTask,

  GetICD10CodesByTerms,
  GetICD10CodesByOrderId,
  GetICD10CodesByPatientId,
  RemoveICD10CodeFromCollection,
  RemoveICD10Codes,
  AddICD10Codes,
  ClearICD10CodesByTerms,

  ChangePassword,
  ChangePIN,

  GetDoctorProfile,
  GetDoctorWeeklySchedule,
  GetDoctorIntegratedCalendar,
  SetDoctorWeeklyScheduleData,
  UpdateDoctorWeeklySchedule,
  RemoveDoctorWeeklySchedule,
  SaveDoctorWeeklySchedule,
  UpdateDoctorWeeklyScheduleTimezone,

  GetReports,
  ClearReports,

  GetDoseSpotV3,
  ResetDoseSpotV3,

  ScheduleVisit,
  GetMedHistory,
 
} from '../data/app/appActions';
import { GetDoctorDateSpecificSchedule,
  SaveDoctorDateSpecificSchedule,
  RemoveDoctorScheduleGroup,
  RemoveDoctorScheduleSlot,DisconnectDoctorIntegratedCalendar } from "../data/app/doctorScheduleActions";
import { GetPatientInsuranceInformation,
  GetPatientInsuranceEligibility,
  GetPayerFormulary,
  GetProductsOther,
  GetPharmaciesOther,
  SaveSelectedPatientEligibilityIdForRx} from "../data/app/benefitsActions";
export const mapStateToProps = (state) => ({
  ...state.appReducer,
  subscribed: state.appReducer.subscribed,
  loading: state.loaderReducer.loading,
  modalOpen: state.appReducer.modalOpen,
  selectedPatientInfo: state.appReducer.selectedPatientInfo,
  selectedPrescriberInfo: state.appReducer.selectedPrescriberInfo,
  notes: state.appReducer.notes,
  productInfo: state.appReducer.productInfo,
  productList: state.appReducer.productList,
  qtyByProduct: state.appReducer.qtyByProduct,
  productListModalError: state.appReducer.productListModalError,
  isProductChangeModalOpen: state.appReducer.isProductChangeModalOpen,
  consultQuestion: state.appReducer.consultQuestion,
  orderNotes: state.appReducer.orderNotes,
  patientNotes: state.appReducer.patientNotes,
  medicalOrderNotes: state.appReducer.medicalOrderNotes,
  medicalPatientNotes: state.appReducer.medicalPatientNotes,
  soapNoteInfo: state.appReducer.soapNoteInfo,
  selectedTab: state.appReducer.selectedTab,
  emailData: state.appReducer.emailData,
  historyData: state.appReducer.historyData,
  emailTemplate: state.appReducer.emailTemplate,
  emailTemplateValue: state.appReducer.emailTemplateValue,
  subjectLine: state.appReducer.subjectLine,
  emailMessage: state.appReducer.emailMessage,
  denialReasonValue: state.appReducer.denialReasonValue,
  denialReason: state.appReducer.denialReason,
  denialReasonText: state.appReducer.denialReasonText,
  approveAndMailData: state.appReducer.approveAndMailData,
  approveAndMailPin: state.appReducer.approveAndMailPin,
  orderAndPrescriberFlag: state.appReducer.orderAndPrescriberFlag,
  approvalOrderFlagValue: state.appReducer.approvalOrderFlagValue,
  approvalPrescriberFlagValue: state.appReducer.approvalPrescriberFlagValue,
  approvalPinError: state.appReducer.approvalPinError,
  errorModalOpen: state.appReducer.errorModalOpen,
  isModalAlertOpen: state.appReducer.isModalAlertOpen,
  callStarted: state.appReducer.callStarted,
  orderNoteText: state.appReducer.orderNoteText,
  addPatientNote: state.appReducer.addPatientNote,
  sendOrderToCSReason: state.appReducer.sendOrderToCSReason,
  sendOrderToCSNote: state.appReducer.sendOrderToCSNote,
  sendOrderToCSReasons: state.appReducer.sendOrderToCSReasons,
  callPatientDetails: state.appReducer.callPatientDetails,
  callToPatientStatus: state.appReducer.callToPatientStatus,
  isModalTwilioAlertOpen: state.appReducer.isModalTwilioAlertOpen,
  isEmailSentToPatient: state.appReducer.isEmailSentToPatient,
  textMessageTemplateValue: state.appReducer.textMessageTemplateValue,
  textmessageTemplateData: state.appReducer.textmessageTemplateData,
  messageValue: state.appReducer.messageValue,
  openTextPatient: state.appReducer.openTextPatient,
  isNoteAdded: state.appReducer.isNoteAdded,
  approveAndSendEmailOpen: state.appReducer.approveAndSendEmailOpen,
  approveAndEmailDone: state.appReducer.approveAndEmailDone,
  denyAndEmailDone: state.appReducer.denyAndEmailDone,
  sendOrderToCSDone: state.appReducer.sendOrderToCSDone,
  denyAndEmailOpen: state.appReducer.denyAndEmailOpen,
  sendOrderToCSOpen: state.appReducer.sendOrderToCSOpen,
  isVideoFocused: state.appReducer.isVideoFocused,
  callDetailSent: state.appReducer.callDetailSent,
  doseSpotData: state.appReducer.doseSpotData,
  isDoseSpotError: state.appReducer.isDoseSpotError,
  isDoseSpotErrorModalOpen: state.appReducer.isDoseSpotErrorModalOpen,
  loggedOff: state.appReducer.loggedOff,
  searchError: state.appReducer.searchError,
  searchData: state.appReducer.searchData,
  pdfExists: state.appReducer.pdfExists,
  getPdf: state.appReducer.getPdf,
  reference: state.appReducer.reference,
  addNoteOpen: state.appReducer.addNoteOpen,
  emailPatientOpen: state.appReducer.emailPatientOpen,
  addSoapNoteOpen: state.appReducer.addSoapNoteOpen,
  callPatientOpen: state.appReducer.callPatientOpen,
  callSummary: state.appReducer.callSummary,
  scheduledVisits: state.appReducer.scheduledVisits,
  asyncOrders: state.appReducer.asyncOrders,
  cmnTemplateFormField: state.appReducer.cmnTemplateFormField,
  soapNoteTemplates: state.appReducer.soapNoteTemplates,
  patientUploads: state.appReducer.patientUploads,
  changeProducts: state.appReducer.changeProducts,
  emailSubjects: state.appReducer.emailSubjects,
  emailReasons: state.appReducer.emailReasons,
  callPatient: state.appReducer.callPatient,
  textPatient: state.appReducer.textPatient,
  emailPatient: state.appReducer.emailPatient,
  productInfoCache: state.appReducer.productInfoCache,
  productCost: state.appReducer.productCost,
  addProductInfo: state.appReducer.addProductInfo,
  loadingProductInfoCacheForOrderId: state.appReducer.loadingProductInfoCacheForOrderId,
});

export const mapDispatchToProps = (dispatch) => ({
  ResetAppState: (data) => {
    dispatch(ResetAppState(data));
  },
  ToggleModal: (data) => dispatch(ToggleModal(data)),
  ResetNotesTab: (data) => {
    dispatch(ResetNotesTab(data));
  },
  ResetEmailTab: (data) => {
    dispatch(ResetEmailTab(data));
  },
  ResetHistoryTab: (data) => {
    dispatch(ResetHistoryTab(data));
  },
  GetScheduleVisitsCards: (data) => dispatch(GetScheduleVisitsCards(data)),
  GetScheduleVisitsLV: () => dispatch(GetScheduleVisitsLV()),
  GetPendingFilesCards: () => dispatch(GetPendingFilesCards()),
  GetPendingFilesLV: () => dispatch(GetPendingFilesLV()),
  GetPatientInfo: (data) => dispatch(GetPatientInfo(data)),
  ResetPatientInfo: (data) => dispatch(ResetPatientInfo(data)),
  GetHeaderInfo: (data) => dispatch(GetHeaderInfo(data)),
  GetPatientMedicalNecessityPDFData: (data) => dispatch(GetPatientMedicalNecessityPDFData(data)),
  GetProductInfo: (data) => dispatch(GetProductInfo(data)),
  GetProductInfoV2: (data) => dispatch(GetProductInfoV2(data)),
  GetSoapNoteInfo: (data) => dispatch(GetSoapNoteInfo(data)),
  GetNotes: (data) => dispatch(GetNotes(data)),
  GetNotesV2: (data = { OrderId: 0 }) => dispatch(GetNotesV2(data)),
  SetProductInfo: (data) => dispatch(SetProductInfo(data)),
  GetProductList: (data) => dispatch(GetProductList(data)),
  GetChangeProductList: (data = {}) => dispatch(GetChangeProductList(data)),
  ResetChangeProductList: () => dispatch(ResetChangeProductList()),
  GetQtyByProduct: (data) => dispatch(GetQtyByProduct(data)),
  SaveProductChanges: (data) => dispatch(SaveProductChanges(data)),
  ChangeProductForOrder: (data = {}) => dispatch(ChangeProductForOrder(data)),
  ToggleProductChangeModal: (data) => dispatch(ToggleProductChangeModal(data)),
  GetConsultQuestions: (data) => dispatch(GetConsultQuestions(data)),
  GetOrderNotes: (data) => dispatch(GetOrderNotes(data)),
  GetPatientNotes: (data) => dispatch(GetPatientNotes(data)),
  GetMedicalOrderNotes: (data) => dispatch(GetMedicalOrderNotes(data)),
  GetMedicalPatientNotes: (data) => dispatch(GetMedicalPatientNotes(data)),
  SetSelectedTab: (data) => {
    dispatch(SetSelectedTab(data));
  },
  GetEmail: (data) => dispatch(GetEmail(data)),
  GetHistory: (data) => dispatch(GetHistory(data)),
  GetEmailTemplate: (data) => dispatch(GetEmailTemplate(data)),
  GetEmailTemplateFromSalesforce: (data = {}) => dispatch(GetEmailTemplateFromSalesforce(data)),
  GetApproveEmailTemplatesFromSalesforce: (data = {}) => dispatch(GetApproveEmailTemplatesFromSalesforce(data)),
  GetDenyEmailTemplatesFromSalesforce: (data = {}) => dispatch(GetDenyEmailTemplatesFromSalesforce(data)),
  GetScheduleEmailTemplatesFromSalesforce: (data = {}) => dispatch(GetScheduleEmailTemplatesFromSalesforce(data)),
  GetDenialReasons: (data) => dispatch(GetDenialReasons(data)),
  SetDenialAndSendValue: (data) => dispatch(SetDenialAndSendValue(data)),
  SetAddNoteValue: (data) => dispatch(SetAddNoteValue(data)),
  SetAddSoapNoteValue: (data) => dispatch(SetAddSoapNoteValue(data)),
  GetSubjectAndMail: (obj, id) => dispatch(GetSubjectAndMail(obj, id)),
  GetSubjectAndMailForAllTemplates: (data) => dispatch(GetSubjectAndMailForAllTemplates(data)),
  GetSubjectAndMailFromSalesforce: (data = {}) => dispatch(GetSubjectAndMailFromSalesforce(data)),
  ResetSubjectAndMailFromSalesforce: (data = {}) => dispatch(ResetSubjectAndMailFromSalesforce(data)),
  DenialAndEmail: (data, handleRouteChange, routePath, callStarted) => dispatch(DenialAndEmail(data, handleRouteChange, routePath, callStarted)),
  AddNote: (data) => dispatch(AddNote(data)),
  AddSoapNote: (data) => dispatch(AddSoapNote(data)),
  ClearEmailAndDenyData: (data) => {
    dispatch(ClearEmailAndDenyData(data));
  },
  GetApproveAndEmailPrepInfo: (data) => {
    dispatch(GetApproveAndEmailPrepInfo(data));
  },
  GetOrderAndPrescriberFlags: (data) => dispatch(GetOrderAndPrescriberFlags(data)),
  ResetOrderAndPrescriberFlags: () => dispatch(ResetOrderAndPrescriberFlags()),

  ResetApproveAndMailData: (data) => {
    dispatch(ResetApproveAndMailData(data));
  },
  SetApproveAndMailData: (data) => {
    dispatch(SetApproveAndMailData(data));
  },
  SetApproveAndMailMainData: (data) => {
    dispatch(SetApproveAndMailMainData(data));
  },
  HandleGlobalValueChange: (data) => {
    dispatch(HandleGlobalValueChange(data));
  },
  OnApproveAndMailClick: (data) => {
    dispatch(OnApproveAndMailClick(data));
  },
  ToggleErrorModal: (data) => {
    dispatch(ToggleErrorModal(data));
  },
  SetModalAlertOpen: (data) => {
    dispatch(SetModalAlertOpen(data));
  },
  SetStartVisit: (data) => {
    dispatch(SetStartVisit(data));
  },
  ClearAddNoteData: (data) => {
    dispatch(ClearAddNoteData());
  },
  GetTokenAndStartVist: (data) => {
    dispatch(GetTokenAndStartVist(data));
  },
  GetSendOrderToCSReasons: () => {
    dispatch(GetSendOrderToCSReasons());
  },
  SendOrderToCS: (data, handleRouteChange, routePath, callStarted) => dispatch(SendOrderToCS(data, handleRouteChange, routePath, callStarted)),
  ResetSendOrderToCS: () => {
    dispatch(ResetSendOrderToCS());
  },
  SetSendOrderToCSData: (data) => {
    dispatch(SetSendOrderToCSData(data));
  },
  GetCallPatientDetails: (data) => dispatch(GetCallPatientDetails(data)),
  SetCallPatientDetails: (data) => {
    dispatch(SetCallPatientDetails(data));
  },
  ResetCallPatientDetails: () => {
    dispatch(ResetCallPatientDetails());
  },
  CallToPatient: (data) => dispatch(CallToPatient(data)),
  CallToPatientPhys: (data) => dispatch(CallToPatientPhys(data)),
  SetModalTwilioAlertOpen: (data) => dispatch(SetModalTwilioAlertOpen(data)),
  EmailPatientDetails: (data) => dispatch(EmailPatientDetails(data)),
  ClearEmailPatientData: (data) => {
    dispatch(ClearEmailPatientData());
  },
  GetTextPatientTemplates: (data) => dispatch(GetTextPatientTemplates(data)),
  TextPatient: (data) => dispatch(TextPatient(data)),
  ResetTextPatientDetails: (data) => {
    dispatch(ResetTextPatientDetails(data));
  },
  CallDetails: (data) => dispatch(CallDetails(data)),
  CallEnd: (data) => dispatch(CallEnd(data)),
  ApproveAndMailSubmit: (data, handleRouteChange, routePath, callStarted) => {
    return dispatch(
      ApproveAndMailSubmit(data, handleRouteChange, routePath, callStarted)
    );
  },
  CompleteVisitAndSendEmail: (data) => dispatch(CompleteVisitAndSendEmail(data)),
  LogError: (data) => {
    dispatch(LogError(data));
  },
  LogOff: (data) => dispatch(LogOff(data)),
  CheckPdfExists: (data) => dispatch(CheckPdfExists(data)),
  SearchData: (data) => dispatch(SearchData(data)),
  ClearSearchData: (data) => dispatch(ClearSearchData(data)),
  GetDoseSpot: (data) => dispatch(GetDoseSpot(data)),
  GetDoseSpotV2: (data) => dispatch(GetDoseSpotV2(data)),
  ResetDoseSpot: () => dispatch(ResetDoseSpot()),
  OrderCallSummaryReasons: () => dispatch(OrderCallSummaryReasons()),
  SetCallSummary: (data) => dispatch(SetCallSummary(data)),
  InsertCallSummary: (data) => dispatch(InsertCallSummary(data)),
  SetFilterBy: (data) => dispatch(SetFilterBy(data)),
  ClearPendingFilesApiStatus: () => dispatch(ClearPendingFilesApiStatus()),
  ClearScheduledVisitsApiStatus: () => dispatch(ClearScheduledVisitsApiStatus()),
  SetCmnTemplateFormField: (data) => dispatch(SetCmnTemplateFormField(data)),
  SetSoapNoteTemplate: (data = {}) => dispatch(SetSoapNoteTemplate(data)),
  GetSoapNoteTemplates: (data = {}) => dispatch(GetSoapNoteTemplates(data)),
  GetPatientUploads: (data = {}) => dispatch(GetPatientUploads(data)),
  DosespotGetPatientPrescriptionsByOrderRequest: (data = {}) => dispatch(DosespotGetPatientPrescriptionsByOrderRequest(data)),

  GetProductInfoV3: (data) => dispatch(GetProductInfoV3(data)),
  ClearProductInfoV3: () => dispatch(ClearProductInfoV3()),

  GetEmailReasons: (data) => dispatch(GetEmailReasons(data)),

  GetProductCost: (data) => dispatch(GetProductCost(data)),
  ResetProductCost: () => dispatch(ResetProductCost()),
  AddProduct: (data) => dispatch(AddProduct(data)),

  GetSavedFlags: (data) => dispatch(GetSavedFlags(data)),
  SaveFlags: (data = []) => dispatch(SaveFlags(data)),
  ResetSavedFlags: (data) => dispatch(ResetSavedFlags(data)),

  SaveExtendedConsult: (data = []) => dispatch(SaveExtendedConsult(data)),

  ResetProductInfoV2: () => dispatch(ResetProductInfoV2()),
  ResetApproveAndEmailPrepInfo: () => dispatch(ResetApproveAndEmailPrepInfo()),
  VerifyPIN: (data = {}) => dispatch(VerifyPIN(data)),
  RemoveOrdersFromLV: ({ orderIds = [] }) => dispatch(RemoveOrdersFromLV({ orderIds })),

  SendPasswordRecoveryOTP: (data = {}) => dispatch(SendPasswordRecoveryOTP(data)),
  ValidatePasswordRecoveryOTP: (data = {}) => dispatch(ValidatePasswordRecoveryOTP(data)),
  ResetPasswordUsingPasswordRecoveryOTP: (data = {}) => dispatch(ResetPasswordUsingPasswordRecoveryOTP(data)),
  ClearRecoverPassword: () => dispatch(ClearRecoverPassword()),

  ValidateToken: () => dispatch(ValidateToken()),
  GetPDFInfo: (data = {}) => dispatch(GetPDFInfo(data)),

  GetTasks: () => dispatch(GetTasks()),
  GetTaskByOrderId: (data = {}) => dispatch(GetTaskByOrderId(data)),
  UpdateTask: (data = {}) => dispatch(UpdateTask(data)),

  GetICD10CodesByTerms: (data) => dispatch(GetICD10CodesByTerms(data)),
  GetICD10CodesByOrderId: (data = {}) => dispatch(GetICD10CodesByOrderId(data)),
  GetICD10CodesByPatientId: (data = {}) => dispatch(GetICD10CodesByPatientId(data)),
  ClearICD10CodesByTerms: (data = {}) => dispatch(ClearICD10CodesByTerms(data)),
  RemoveICD10CodeFromCollection: (data = {}) => dispatch(RemoveICD10CodeFromCollection(data)),
  AddICD10Codes: (data = {}) => dispatch(AddICD10Codes(data)),
  RemoveICD10Codes: (data = {}) => dispatch(RemoveICD10Codes(data)),

  ChangePassword: async (data = {}) => dispatch(ChangePassword(data)),
  /**
   * 
   * @param {{
   *  currentPIN: string;
   *  newPIN: string;
   * }} data 
   * @returns {Promise<{
   *  status: number;
   * }>}
   */
  ChangePIN: async (data = {}) => dispatch(ChangePIN(data)),

  GetDoctorProfile: async () => dispatch(GetDoctorProfile()),
  GetDoctorWeeklySchedule: async () => dispatch(GetDoctorWeeklySchedule()),
  GetDoctorIntegratedCalendar: async () => dispatch(GetDoctorIntegratedCalendar()),
  DisconnectDoctorIntegratedCalendar: (data = {}) => dispatch(DisconnectDoctorIntegratedCalendar(data)),
  SetDoctorWeeklyScheduleData: (data = {}) => dispatch(SetDoctorWeeklyScheduleData(data)),
  UpdateDoctorWeeklySchedule: (data = {}) => dispatch(UpdateDoctorWeeklySchedule(data)),
  RemoveDoctorWeeklySchedule: (data = {}) => dispatch(RemoveDoctorWeeklySchedule(data)),
  SaveDoctorWeeklySchedule: (data = {}) => dispatch(SaveDoctorWeeklySchedule(data)),
  UpdateDoctorWeeklyScheduleTimezone: (data = {}) => dispatch(UpdateDoctorWeeklyScheduleTimezone(data)),
  GetDoctorDateSpecificSchedule: async () => dispatch(GetDoctorDateSpecificSchedule()),
  SaveDoctorDateSpecificSchedule: async (data = {}) => dispatch(SaveDoctorDateSpecificSchedule(data)),
  RemoveDoctorScheduleGroup: async (groupGuid, updatedBy) => dispatch(RemoveDoctorScheduleGroup(groupGuid, updatedBy)),
  RemoveDoctorScheduleSlot: async (id = {}, updatedBy) => dispatch(RemoveDoctorScheduleSlot(id, updatedBy)), 
  GetPatientInsuranceEligibility: (data = {}) => dispatch(GetPatientInsuranceEligibility(data)),
  /**
   * 
   * @param {{
   *  startDate: string;
   *  endDate: string;
   * }} data 
   * @returns {Promise<{
   *  status: number;
   * }>}
   */
  GetReports: async (data) => dispatch(GetReports(data)),
  ClearReports: () => dispatch(ClearReports()),

  /**
   *  
   * @returns {Promise<{
   *  status: number;
   * }>}
   */
  GetDoseSpotV3: async () => dispatch(GetDoseSpotV3()),
  ResetDoseSpotV3: () => dispatch(ResetDoseSpotV3()),

  ScheduleVisit: async (data) => dispatch(ScheduleVisit(data)),
  GetMedHistory: (data = {}) => dispatch(GetMedHistory(data)),
  GetPatientInsuranceInformation: (data = {}) => dispatch(GetPatientInsuranceInformation(data)),
  GetPatientInsuranceEligibility: (data = {}) => dispatch(GetPatientInsuranceEligibility(data)),
  GetPayerFormulary: (data = {}) => dispatch(GetPayerFormulary(data)),
  SaveSelectedPatientEligibilityIdForRx: (data = {}) => dispatch(SaveSelectedPatientEligibilityIdForRx(data)),
  GetProductsOther: (data = {}) => dispatch(GetProductsOther(data)),
  GetPharmaciesOther: (data = {}) => dispatch(GetPharmaciesOther(data)),
});

export const Container = (Component) => withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Component));

export default Container;
